import React, { useState, useEffect } from 'react';
import { createUser, getUserByHandle, updateUserStatus } from '../services/chatService';

const Login = ({ onLogin, onFirstTimeUser, onClose }) => {
    const [handle, setHandle] = useState('');
    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    // Check if user exists in localStorage
    useEffect(() => {
        const existingUsers = JSON.parse(localStorage.getItem('goodVibesUsers') || '[]');
        if (existingUsers.length === 0) {
            // No users exist, but don't auto-redirect - let user choose
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            // Check if user exists in Firebase
            const existingUser = await getUserByHandle(handle);

            if (existingUser) {
                // User exists, check if code matches
                if (existingUser.code === code) {
                    // Update user status to online
                    await updateUserStatus(existingUser.id, true);

                    // Save to localStorage for local session
                    const userData = {
                        id: existingUser.id,
                        handle: existingUser.handle,
                        code: existingUser.code,
                        name: existingUser.name,
                        email: existingUser.email,
                        isOnline: true,
                        createdAt: existingUser.createdAt
                    };
                    localStorage.setItem('currentUser', JSON.stringify(userData));
                    onLogin(userData);
                } else {
                    setError('Invalid code for this handle');
                }
            } else {
                // New user - create account in Firebase
                const newUser = await createUser(handle, handle, code);

                // Save to localStorage for local session
                const userData = {
                    id: newUser.id,
                    handle: newUser.handle,
                    code: newUser.code,
                    name: newUser.name,
                    email: newUser.email,
                    isOnline: true,
                    createdAt: newUser.createdAt
                };
                localStorage.setItem('currentUser', JSON.stringify(userData));
                onLogin(userData);
            }
        } catch (err) {
            console.error('Login error:', err);
            setError('Login failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleCodeChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 4);
        setCode(value);
    };

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget && onClose) {
            onClose();
        }
    };

    return (
        <div className="login-container" onClick={handleBackdropClick}>
            <div className="login-window">
                <div className="login-header">
                    <h1>GOOD VIBES* #ccfc</h1>
                    <p>Welcome! Sign in or create a new account</p>
                    {onClose && (
                        <button className="close-login" onClick={onClose}>×</button>
                    )}
                </div>

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="form-group">
                        <label htmlFor="handle">Handle</label>
                        <input
                            type="text"
                            id="handle"
                            value={handle}
                            onChange={(e) => setHandle(e.target.value)}
                            placeholder="Enter your handle"
                            required
                            className="login-input"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="code">4-Digit Code</label>
                        <input
                            type="text"
                            id="code"
                            value={code}
                            onChange={handleCodeChange}
                            placeholder="0000"
                            maxLength="4"
                            required
                            className="login-input code-input"
                        />
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <button
                        type="submit"
                        className="login-button"
                        disabled={isLoading || handle.length === 0 || code.length !== 4}
                    >
                        {isLoading ? 'Signing In...' : 'Sign In / Create Account'}
                    </button>
                </form>

                <div className="login-footer">
                    <p>First time?</p>
                    <button
                        type="button"
                        className="signup-button"
                        onClick={onFirstTimeUser}
                    >
                        Sign up with a new name
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Login;